import { DefaultButton } from "../buttons/DefaultButton";
import { IconLink } from "../../assets/icons/icons";

interface IntegrationCardInfoProps {
  title: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
  error?: string;
}

export const IntegrationCardInfo = ({
  title,
  description,
  buttonText,
  buttonLink,
  error,
}: IntegrationCardInfoProps) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{title}</h2>

      <div className="space-y-1 text-gray-700">
        <p>{description}:</p>

        {error && <p className="">{error}</p>}
      </div>

      {buttonText && buttonLink && (
        <div className="flex justify-end py-4">
          <DefaultButton
            title={buttonText}
            onClick={() => {
              window.open(buttonLink, "_blank");
            }}
            isLoading={false}
            icon = {
              <IconLink color={"#5050EA"} width="20px" height="20px" />  
            }
          />
        </div>
      )}
    </div>
  );
};
